import React from 'react'
import { JaContent } from '@/components/organisms/termsOfUse/ja-content'
import { Layout } from '@/components/template/layout'
import { useTranslation } from 'react-i18next'
import { EnContent } from '@/components/organisms/termsOfUse/en-content'
import { KoContent } from '@/components/organisms/termsOfUse/ko-content'
import { ZhContent } from '@/components/organisms/termsOfUse/zh-content'
import { ZhTwContent } from '@/components/organisms/termsOfUse/zh-tw-content'
import { useQuerySearchParams } from '@/hooks/use-query-search-params'
import { StaticLayout } from '@/components/template/static-layout'

export const TermsOfUse: React.FC = () => {
  const {
    i18n: { language },
  } = useTranslation()

  const { hotelId } = useQuerySearchParams<{ hotelId?: string }>()

  const contents = {
    ja: <JaContent />,
    en: <EnContent />,
    ko: <KoContent />,
    zh: <ZhContent />,
    zhTw: <ZhTwContent />,
  }

  return hotelId ? <Layout>{contents[language]}</Layout> : <StaticLayout>{contents[language]}</StaticLayout>
}
